export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7233.f213438a.jpg";